import { useSelector } from "react-redux";
import useSetting from "./useSetting";
import SettingKeys from "../utils/SettingKeys";
import { isEmpty, listFromCsv } from "../utils/helpers";
import { Role } from "../utils/types";

const useEntityPrivilege = entityName => {
  const authState = useSelector(state => state.jazasoft.auth);
  const roles = authState?.roleList?.map(e => e.role?.roleId).filter(roleId => !isEmpty(roleId)) || [];

  const disableEntitiesDelete = useSetting(SettingKeys.DISABLE_ENTITIES_DELETE);
  const disableEntitiesEdit = useSetting(SettingKeys.DISABLE_ENTITIES_EDIT);
  const disableEntitiesCreate = useSetting(SettingKeys.DISABLE_ENTITIES_CREATE);
  const entityDeleteList = isEmpty(disableEntitiesDelete) ? [] : listFromCsv(disableEntitiesDelete).map(e => e.toLowerCase());
  const entityEditList = isEmpty(disableEntitiesEdit) ? [] : listFromCsv(disableEntitiesEdit).map(e => e.toLowerCase());
  const entityCreateList = isEmpty(disableEntitiesCreate) ? [] : listFromCsv(disableEntitiesCreate).map(e => e.toLowerCase());
  const disableDelete =
    !isEmpty(roles) &&
    !roles.includes(Role.MASTER) &&
    !roles.includes(Role.SUPER_USER) &&
    !roles.includes(Role.ADMIN_USER) &&
    entityDeleteList.includes(entityName.toLowerCase());
  const disableEdit =
    !isEmpty(roles) &&
    !roles.includes(Role.MASTER) &&
    !roles.includes(Role.SUPER_USER) &&
    !roles.includes(Role.ADMIN_USER) &&
    entityEditList.includes(entityName.toLowerCase());
  const disableCreate =
    !isEmpty(roles) &&
    !roles.includes(Role.MASTER) &&
    !roles.includes(Role.SUPER_USER) &&
    !roles.includes(Role.ADMIN_USER) &&
    entityCreateList.includes(entityName.toLowerCase());

  return { disableCreate, disableEdit, disableDelete };
};

export default useEntityPrivilege;
